import { getMapByKey, getMapByStringKey } from '../libs/helpTools'

export default {
  props: {
    title: {
      type: [String, Number],
      default: ''
    },
    placeholder: [String, Number],
    search: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    intersectionScroll: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    idFieldName: {
      type: String,
      default: 'id'
    },
    titleFieldName: {
      type: String,
      default: 'name'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    clearableValue: {
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    showArrowIcon: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: Number,
      default: 270
    },
    emptyText: {
      type: String,
      default: 'Ничего не найдено'
    },
    error: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    searchValue: {
      type: String
    },
    customFilter: {
      type: Boolean,
      required: false
    },
    hasDescription: {
      type: Boolean,
      default: false
    },
    hasTitle: {
      type: Boolean,
      default: true
    },
    strictComparison: {
      type: Boolean,
      default: true
    },
    type: String
  },

  data () {
    return {
      innerSearchText: ''
    }
  },

  computed: {
    innerSearchValue: {
      get () {
        return this.customFilter ? this.searchValue : this.innerSearchText
      },
      set (value) {
        if (this.customFilter) {
          this.$emit('update:search-value', value)
          return
        }
        this.innerSearchText = value
      }
    },
    isEqual () {
      return this.strictComparison
        ? (a, b) => a === b
        : (a, b) => a == b
    },
    selectContainerProps () {
      return {
        title: this.title,
        placeholder: this.placeholder,
        search: this.search,
        small: this.small,
        intersectionScroll: this.intersectionScroll,
        disabled: this.disabled,
        idFieldName: this.idFieldName,
        titleFieldName: this.titleFieldName,
        isClear: this.clearable,
        multiple: this.multiple,
        showArrowIcon: this.showArrowIcon,
        maxHeight: this.maxHeight,
        emptyText: this.emptyText,
        error: this.error,
        appendToBody: this.appendToBody,
        searchValue: this.innerSearchValue,
        hasDescription: this.hasDescription,
        hasTitle: this.hasTitle,
        badgeTextColor: this.badgeTextColor,
        badgeBackgroundColor: this.badgeBackgroundColor,
        type: this.type,
        clearableValue: this.clearableValue
      }
    },
    selectContainerListeners () {
      const listeners = {
        ...this.$listeners,
        'update:search-value': value => this.innerSearchValue = value
      }
      delete listeners.input
      return listeners
    }
  },
  methods: {
    change (item) {
      if (this.multiple) {
        this.multipleChange(item)
        return
      }
      this.onceChange(item)
    },
    multipleChange (item) {
      const index = this.innerValue.findIndex(id => this.isEqual(id, item[this.idFieldName]))

      if (index !== -1) {
        const cloneValue = [...this.innerValue]
        cloneValue.splice(index, 1)
        this.innerValue = cloneValue
        return
      }

      this.innerValue = [...this.innerValue, item[this.idFieldName]]
    },
    onceChange (item) {
      // TODO убрать когда в UiChessMenu заменят UiSelect на UiButtonSelect
      if (item?.event) {
        item.event()
        this.$emit('custom-event')
      }
      this.$emit('change', item)
      const isActiveItem = this.isEqual(item[this.idFieldName], this.innerValue)
      if (isActiveItem) {
        if (!this.clearable) return
        this.innerValue = null
        return
      }
      this.innerValue = item[this.idFieldName]
    },
    getMapList (list) {
      return this.strictComparison
        ? getMapByKey(list, this.idFieldName)
        : getMapByStringKey(list, this.idFieldName)
    }
  }
}
